import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {Modal, Form, Grid, Label, Input, Dropdown, TextArea, Button, Icon} from 'semantic-ui-react';
import {returnRequestTypes, returnClaimTypes} from '../../../../common/dictionaries/parameters';
import {shortDate, dateFormatPicker, noTimeZoneFullISODate} from '../../../../common/constants/datesFormat';
import {Actions} from '../../../../common/actions';
import {parseDate} from '../../../../common/util/options';
import ClaimMessage from './message';
import Processor from './processor';

const parseClaims = () => {
  return Object.keys(returnClaimTypes).map((acceptanceType) => {
    return {'text': returnClaimTypes[acceptanceType], 'value': acceptanceType};
  });
};

const parseRequests = () => {
  return Object.keys(returnRequestTypes).map((acceptanceType) => {
    return {'text': returnRequestTypes[acceptanceType], 'value': acceptanceType};
  });
};

class Claim extends Component {
  constructor(props) {
    super(props);
    this.state = {'isOpen': false};
    this.handleBlur = this.handleBlur.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSelection = this.handleSelection.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
    this.handleCommentsChange = this.handleCommentsChange.bind(this);
  }

  handleOpen() {
    const {currentClaim} = this.props;

    this.setState({'isOpen': true});

    if (currentClaim) {
      this.props.selectReturnOrderClaim(currentClaim);
      return;
    }
    this.props.clearReturnOrderClaim();
  }

  handleClose() {
    this.setState({'isOpen': false});
    this.props.clearReturnOrderClaim();
  }

  handleChange(event, {name, value}) {
    this.props.editReturnClaimValue(name, value.trim().toUpperCase());
  }

  handleSelection(event, {name, value}) {
    this.props.editReturnClaimValue(name, value);
  }

  handleQuantityChange(event, {name, value}) {
    this.props.editReturnClaimValue(name, parseInt(value, 10));
  }

  handleDateChange(value) {
    this.props.editReturnClaimValue('receptionDate', value ? moment(value).format(noTimeZoneFullISODate) : null);
  }

  handleCommentsChange(event, {name, value}) {
    this.props.editReturnClaimValue(name, value);
  }

  handleBlur() {
    const {invoiceSerial, invoiceNumber, partCode} = this.props;

    if (invoiceSerial && invoiceNumber && partCode) {
      this.props.getClaimSaleData({partCode, invoiceSerial, invoiceNumber});
    }
  }

  renderTrigger() {
    const {returnOrder, icon, processingOrder} = this.props;

    if (returnOrder && returnOrder.status !== 'I') {
      return null;
    }
    
    if (icon) {
      return (<Icon link size='large' name='write' onClick={this.handleOpen} />);
    }
    return (<Button secondary content='AGREGAR' disabled={processingOrder} onClick={this.handleOpen} />);
  }

  render() {
    const {processing, invoiceSerial, invoiceNumber, invoiceDate, invoicedQuantity, referralGuide,
      receptionDate, partCode, claimedQuantity, claimCode, requestCode, dealerComments, index} = this.props;

    return (
      <Modal closeIcon
        className='claim-modal'
        open={this.state.isOpen}
        onClose={this.handleClose}
        trigger={this.renderTrigger()}
      >
        <Modal.Header>Solicitud de Devolución</Modal.Header>
        <Modal.Content>
          <ClaimMessage />
          <Form>
            <Grid>
              <Grid.Row>
                <Grid.Column width='8'>
                  <label><strong>Número de serie</strong></label>
                  <Input fluid
                    name='invoiceSerial'
                    maxLength='6'
                    value={invoiceSerial}
                    disabled={processing}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                  />
                </Grid.Column>
                <Grid.Column width='8'>
                  <label><strong>Factura</strong></label>
                  <Input fluid
                    name='invoiceNumber'
                    maxLength='20'
                    value={invoiceNumber}
                    disabled={processing}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width='8'>
                  <label><strong>Repuesto</strong></label>
                  <Input fluid
                    name='partCode'
                    maxLength='20'
                    value={partCode}
                    disabled={processing}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                  />
                </Grid.Column>
                <Grid.Column width='8'>
                  <label><strong>Guía courier</strong></label>
                  <Input fluid
                    name='referralGuide'
                    maxLength='20'
                    value={referralGuide}
                    disabled={processing}
                    onChange={this.handleChange}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width='8'>
                  <label><strong>Fecha de facturación</strong></label>
                  <Label size='large'>{invoiceDate ? moment(invoiceDate).format(shortDate) : null}</Label>
                </Grid.Column>
                <Grid.Column width='8'>
                  <label><strong>Fecha de recepción</strong></label>
                  <DatePicker
                    locale='es'
                    customInput={<Input fluid icon='calendar' />}
                    dateFormat={dateFormatPicker}
                    selected={parseDate(receptionDate)}
                    disabled={processing}
                    onChange={this.handleDateChange}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width='8'>
                  <label><strong>Cant. Factura</strong></label>
                  <Label size='large'>{invoicedQuantity}</Label>
                </Grid.Column>
                <Grid.Column width='8'>
                  <label><strong>Cant. Devolución</strong></label>
                  <Input fluid
                    type='number'
                    name='claimedQuantity'
                    min='1'
                    max={invoicedQuantity}
                    value={claimedQuantity}
                    disabled={processing}
                    onChange={this.handleQuantityChange}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width='8'>
                  <label><strong>Reclamo</strong></label>
                  <Dropdown fluid selection
                    name='claimCode'
                    value={claimCode}
                    options={parseClaims()}
                    disabled={processing}
                    onChange={this.handleSelection}
                  />
                </Grid.Column>
                <Grid.Column width='8'>
                  <label><strong>Petición</strong></label>
                  <Dropdown fluid selection
                    name='requestCode'
                    value={requestCode}
                    options={parseRequests()}
                    disabled={processing}
                    onChange={this.handleSelection}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <label><strong>Comentarios</strong></label>
                  <TextArea
                    rows='3'
                    name='dealerComments'
                    value={dealerComments}
                    disabled={processing}
                    onChange={this.handleCommentsChange}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Processor index={index} handleClose={this.handleClose} />
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  const {loading, processing, invoiceSerial, invoiceNumber, invoiceDate, invoicedQuantity, referralGuide, receptionDate,
    partCode, claimedQuantity, claimCode, requestCode, dealerComments, processed} = state.returnClaim;

  return {
    loading, processing, invoiceSerial, invoiceNumber, invoiceDate, invoicedQuantity, referralGuide,
    receptionDate, partCode, claimedQuantity, claimCode, requestCode, dealerComments, processed,
    'returnOrder': state.partsReturnsOrders.selectedOrder,
    'processingOrder': state.partsReturnsOrders.processing,
  };
};

const {
  selectReturnOrderClaim,
  clearReturnOrderClaim,
  editReturnClaimValue,
  getClaimSaleData,
} = Actions;

export default connect(mapStateToProps, {
  selectReturnOrderClaim,
  clearReturnOrderClaim,
  editReturnClaimValue,
  getClaimSaleData,
})(Claim);
